
























import Vue from 'vue'
import axios from 'axios'
import zenscroll from 'zenscroll'
import moment from 'moment';

import { Component } from 'vue-property-decorator'
import SectionBase from '@/mixins/SectionBase'
import { Field } from '@/model/Field'
import { API_URL } from '@/config'
import ServiceSectionBase from './ServiceSectionBase'

@Component({
  mixins: [SectionBase, ServiceSectionBase],
})
export default class SectionSubmit extends ServiceSectionBase {
  status: 'ready' | 'not-valid' | 'submitting' | 'succeeded' | 'failed' = 'ready'
  inquiryId = null
  hiddenInput = ''

  get pdfUrl (): string {
    return `${API_URL}/service_inquiry/${this.inquiryId}/pdf`
  }

  get submitting (): boolean {
    return !this.notValid && this.status === 'submitting'
  }

  get succeeded (): boolean {
    return !this.notValid && this.status === 'succeeded'
  }

  get failed (): boolean {
    return !this.notValid && this.status === 'failed'
  }

  get notValid (): boolean {
    return this.$validator.errors.count() > 0 || this.status === 'not-valid'
  }

  get showVacationMessage (): boolean {
    const vacationStart = moment.utc([2018, 6, 5, 14, 0, 0]);
    const vacationEnd = moment.utc([2018, 7, 13, 6, 0, 0]);
    const now = moment.utc();

    return now.isBetween(vacationStart, vacationEnd);
  }

  scrollToFirstError () {
    let topmostError = this.$validator.errors.items[0]
    let topmostErrorEl = document.getElementById(`${topmostError.field}-input`);
    if (!topmostErrorEl) {
      throw new Error(`Field '${topmostError.field}' could not be found`)
    }
    let topmostErrorPos = topmostErrorEl.getBoundingClientRect().top + window.pageYOffset

    for (let error of this.$validator.errors.items) {
      let el = document.getElementById(`${error.field}-input`)
      if (!el) {
        throw new Error(`Field '${error.field}' could not be found`)
      }

      let pos = el.getBoundingClientRect().top + window.pageYOffset
      if (pos < topmostErrorPos) {
        topmostError = error
        topmostErrorEl = el
        topmostErrorPos = pos
      }
    }

    zenscroll.center(topmostErrorEl)
  }

  submit () {
    this.$validator.validateAll().then(success => {
      if (success) {
        this.status = 'submitting'

        const testmail = this.hiddenInput == 'testmail';

        this.$store.dispatch('serviceForm/sendInquiry', testmail).then(id => {
          this.status = 'succeeded'
          this.inquiryId = id
        }, error => {
          console.error("Could not post inquiry.")
          this.status = 'failed'
        });
      } else {
        this.status = 'not-valid'

        this.scrollToFirstError()
      }
    })
  }
}
